import restApi from '@/rest-api'

export default {
    getPartnersByFilter(page, filter, sortOption, order) {
        var path = page ? `/partner/filtered?page=${page}&per_page=10&` : '/partner/filtered?'
        if (sortOption) {
            path += `sortOption=${sortOption}&order=${order}`
        }
        return restApi.post(path, filter)
    }
}
